import { Routes } from '@angular/router';
import { PermissionGuard } from 'src/app/auth/guard/permission.guard';

export const REPORT_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },
  {
    path: 'posted-transaction-report',
    loadChildren: () => import('./posted-transaction-report/posted-transaction-report.module').then(x=>x.PostedTransactionReportModule),
    data: {
      icon: '',
      name: 'Posted Transaction Report',
      global: false,
      perSchema: true,
      permissions: [ 'PTXNR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'detailed-settlement-report',
    loadChildren: () => import('./detailed-settlement-report/detailed-settlement-report.module').then(x=>x.DetailedSettlementReportModule),
    data: {
      icon: '',
      name: 'Detailed Settlement Report',
      global: false,
      perSchema: true,
      permissions: [ 'STLMR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'patient-registration-details-report',
    loadChildren: () => import('./patient-registration-details-report/patient-registration-details-report.module').then(x=>x.PatientRegistrationDetailsReportModule),
    data: {
      icon: '',
      name: 'Patient Registration Details Report',
      global: false,
      perSchema: true,
      permissions: [ 'PRDR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'monthly-transaction-otp-report',
    loadChildren: () => import('./monthly-transaction-otp-report/monthly-transaction-otp-report.module').then(x=>x.MonthlyTransactionOTPReportModule),
    data: {
      icon: '',
      name: 'Monthly Transaction OTP Report',
      global: false,
      perSchema: true,
      permissions: [ 'MOTR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'channel-activity-report',
    loadChildren: () => import('./customer-registration-and-activity-report/customer-registration-and-activity-report.module').then(x=>x.CustomerRegistrationAndActivityReportModule),
    data: {
      icon: '',
      name: 'Channel Activity Report',
      global: false,
      perSchema: true,
      permissions: [ 'CRAR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'monthly-transaction-otp-report',
    loadChildren: () => import('./monthly-transaction-otp-report/monthly-transaction-otp-report.module').then(x=>x.MonthlyTransactionOTPReportModule),
    data: {
      icon: '',
      name: 'Monthly Transaction OTP Report',
      global: false,
      perSchema: true,
      permissions: [ 'MOTR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'customer-first-purchase-report',
    loadChildren: () => import('./customer-first-purchase-report/customer-first-purchase-report.module').then(x=>x.CustomerFirstPurchaseReportModule),
    data: {
      icon: '',
      name: 'Customer First Purchase Report',
      global: false,
      perSchema: true,
      permissions: [ 'CFPR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'customer-transactions-report',
    loadChildren: () => import('./customer-transactions-report/customer-transactions-report.module').then(x=>x.CustomerTransactionsReportModule),
    data: {
      icon: '',
      name: 'Customer Transactions Summary Report',
      global: false,
      perSchema: true,
      permissions: [ 'CTR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  // {
  //   path: 'payment-summary-report',
  //   loadChildren: () => import('./payment-summary-report/payment-summary-report.module').then(x=>x.PaymentSummaryReportModule),
  //   data: {
  //     icon: '',
  //     name: 'Payment Summary Report',
  //     global: false,
  //     perSchema: true,
  //     permissions: [ 'PTSMR-VIEW' ]
  //   },
  //   canActivate: [ PermissionGuard ]
  // },
  {
    path: 'patient-count-by-territory',
    loadChildren: () => import('./summary-by-territory-report/summary-by-territory-report.module').then(x=>x.SummaryByTerritoryReportModule),
    data: {
      icon: '',
      name: 'Patient Count by Territory Report',
      global: false,
      perSchema: true,
      permissions: [ 'SBTR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'quantity-purchased-by-doctor',
    loadChildren: () => import('./quantity-purchased-by-doctor/quantity-purchased-by-doctor.module').then(x=>x.QuantityPurchasedByDoctorModule),
    data: {
      icon: '',
      name: 'Quantity Purchased by Doctor Report',
      global: false,
      perSchema: true,
      permissions: [ 'QPDR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'new-customer-count-by-recipient',
    loadChildren: () => import('./new-customer-count-by-recipient/new-customer-count-by-recipient.module').then(x=>x.NewCustomerCountByRecipientModule),
    data: {
      icon: '',
      name: 'New Patient Count by Doctor Report',
      global: false,
      perSchema: true,
      permissions: [ 'NPCDR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'usage-rate-summary',
    loadChildren: () => import('./usage-rate-summary/usage-rate-summary.module').then(x=>x.UsageRateSummaryModule),
    data: {
      icon: '',
      name: 'Usage Rate Summary Report',
      global: false,
      perSchema: true,
      permissions: [ 'URSR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
  {
    path: 'allocation-and-receiving-running-balance',
    loadChildren: () => import('./allocation-and-receiving-running-balance/allocation-and-receiving-running-balance.module').then(x=>x.AllocationAndReceivingRunningBalanceModule),
    data: {
      icon: '',
      name: 'Allocation and Receiving Running Balance Report',
      global: false,
      perSchema: true,
      permissions: [ 'ARRBR-VIEW' ]
    },
    canActivate: [ PermissionGuard ]
  },
];
